import { useEffect, useState } from 'react'
import { getLocalStorage } from 'lib/storage'

export const LOCALSTORAGE_AFFILIATE_PROPERTYS = 'sfl_affiliate_propertys'
export const TTL = 24 * 60 * 60 * 1000 // 1 day
export const MAX_ITEMS = 30

const removeAffiliatePropertyStorage = propertyId => {
  const affiliateProperties = getLocalStorage(LOCALSTORAGE_AFFILIATE_PROPERTYS)
  delete affiliateProperties[propertyId]
  localStorage?.setItem(LOCALSTORAGE_AFFILIATE_PROPERTYS, JSON.stringify(affiliateProperties))
}

const purgeAffiliateProperties = affiliateProperties => {
  const now = Date.now()
  const lastPurge = affiliateProperties?.lastPurge || false

  if (!!lastPurge && lastPurge > now - TTL) {
    return { ...affiliateProperties }
  }

  const purgedAffiliateProperties = {}
  Object.keys(affiliateProperties).forEach(propertyId => {
    const { affiliate = null, expires = 0 } = affiliateProperties[propertyId] || {}
    if (!!expires && !!affiliate && parseInt(expires) >= now - TTL) {
      purgedAffiliateProperties[propertyId] = { ...affiliateProperties[propertyId] }
    }
  })

  purgedAffiliateProperties.lastPurge = now

  localStorage?.setItem(LOCALSTORAGE_AFFILIATE_PROPERTYS, JSON.stringify(purgedAffiliateProperties))

  return purgedAffiliateProperties
}

const getAffiliateProperties = () => {
  const affiliateProperties = getLocalStorage(LOCALSTORAGE_AFFILIATE_PROPERTYS)
  const purgedAffiliateProperties = purgeAffiliateProperties(affiliateProperties)
  return purgedAffiliateProperties
}

const setAffiliatePropertyStorage = (propertyId, affiliateId, source) => {
  const affiliateProperties = getAffiliateProperties()
  const propertyIds = Object.keys(affiliateProperties)
  if (propertyIds.length >= MAX_ITEMS) {
    delete affiliateProperties[propertyIds[0]]
  }
  affiliateProperties[propertyId] = { affiliate: affiliateId, source, expires: Date.now() + TTL }
  localStorage?.setItem(LOCALSTORAGE_AFFILIATE_PROPERTYS, JSON.stringify(affiliateProperties))
}

const getAffiliateProperty = propertyId => {
  const now = Date.now()
  const affiliateProperties = getAffiliateProperties()
  const affiliateProperty = affiliateProperties[propertyId] || {}
  const { affiliate = null, expires = 0, source } = affiliateProperty

  if (!!expires && parseInt(expires) < now) {
    removeAffiliatePropertyStorage(propertyId)
    return { affiliate: null, source: null }
  }
  return { affiliate, source }
}

const useStorageAffiliateProperty = propertyId => {
  const [propertyAffiliateData, setPropertyAffiliateData] = useState(null)

  useEffect(() => {
    const affiliatePropertyData = getAffiliateProperty(propertyId)
    if (!affiliatePropertyData) {
      return
    }
    setPropertyAffiliateData(affiliatePropertyData)
  }, [propertyId])

  const setAffiliateProperty = (affiliateId, sourceProperty) => {
    setAffiliatePropertyStorage(propertyId, affiliateId, sourceProperty)
    setPropertyAffiliateData({ affiliate: affiliateId, source: sourceProperty })
  }

  return { ...propertyAffiliateData, setAffiliateProperty }
}

export default useStorageAffiliateProperty
